import axios from 'src/utils/axios';
import moment from 'moment';

export const GET_METRICS = '@analytics-actions/get-metrics';
export const SET_DATE_RANGE = '@analytics-actions/set-date-range';

export function fetchMetrics(botId, dateRange) {
  const startDate = moment(dateRange[0]).unix();
  const endDate = moment(dateRange[1]).unix();
  const request = axios.get(`/api/analytics/${botId}`, {
    params: {
      channel: 'all',
      start: startDate,
      end: endDate
    }
  });

  return (dispatch) => {
    request.then((response) => {
      dispatch({
        type: GET_METRICS,
        payload: response.data
      })
    }
    );
  };
}

export function setDateRange(dateRange) {
  return (dispatch) =>
    dispatch({
      type: SET_DATE_RANGE,
      payload: { dateRange }
    });
}
